import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import type {
  IbhBasketRequestDto,
  IbhBasketResponseDto,
  IbhIcnBasketRequestDto,
  IbhIcnUpdateBasketRequestDto,
  IbhUpdateBasketIcnParams,
  IbhUpdateBasketRequestDto,
} from '@igus/iglidur-bearing-hub-api/src/data-contracts';
import type { Session } from '@hub/hooks/states/useSessionStore';
import * as Sentry from '@sentry/nextjs';

const isIcnBasketRequest = (
  dto: IbhBasketRequestDto | IbhIcnBasketRequestDto | IbhUpdateBasketRequestDto | IbhUpdateBasketIcnParams
): dto is IbhIcnBasketRequestDto =>
  typeof dto === 'object' && dto !== null && 'configurationId' in dto && 'userId' in dto;

export const addToBasket = async (
  { sessionId }: Session,
  ibhBasketRequestDto: IbhBasketRequestDto | IbhIcnBasketRequestDto
): Promise<IbhBasketResponseDto> => {
  try {
    let response: { data: IbhBasketResponseDto };
    if (isIcnBasketRequest(ibhBasketRequestDto)) {
      response = await ibhApiService.addToBasketIcn({ sid: sessionId }, ibhBasketRequestDto);
    } else {
      response = await ibhApiService.addToBasket({ sid: sessionId }, ibhBasketRequestDto);
    }
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      contexts: {
        request: {
          sessionId,
          requestData: ibhBasketRequestDto,
        },
      },
      tags: {
        api_call: 'addToBasket',
      },
      level: 'error',
    });

    throw new Error('Could not add item to basket');
  }
};

export const updateBasket = async (
  { sessionId }: Session,
  ibhUpdateBasketRequestDto: IbhUpdateBasketRequestDto | IbhIcnUpdateBasketRequestDto
): Promise<IbhBasketResponseDto> => {
  try {
    let response: { data: IbhBasketResponseDto };
    if (isIcnBasketRequest(ibhUpdateBasketRequestDto)) {
      response = await ibhApiService.updateBasketIcn({ sid: sessionId }, ibhUpdateBasketRequestDto);
    } else {
      response = await ibhApiService.updateBasket({ sid: sessionId }, ibhUpdateBasketRequestDto);
    }
    return response.data;
  } catch (error) {
    Sentry.captureException(error, {
      contexts: {
        request: {
          sessionId,
          requestData: ibhUpdateBasketRequestDto,
        },
      },
      tags: {
        api_call: 'updateBasket',
      },
      level: 'error',
    });

    throw new Error('Could not update basket');
  }
};
